import { createAction } from 'redux-actions';

export const addItemLocationZoneOption = createAction(
  'ADD_INVENTORY_ITEM_LOCATION_ZONE_OPTION'
);

export const updateItemLocationZoneOption = createAction(
  'UPDATE_INVENTORY_ITEM_LOCATION_ZONE_OPTION'
);

export const removeItemLocationZoneOption = createAction(
  'REMOVE_INVENTORY_ITEM_LOCATION_ZONE_OPTION'
);
